var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center mx-3 d-none d-sm-block"},[_c('CIcon',{class:[_vm.isConnected ? 'text-success' : 'text-danger'],attrs:{"name":"cil-print"}}),_c('CBadge',{staticClass:"ml-1",attrs:{"color":_vm.isConnected ? 'success' : 'danger'}},[_vm._v(_vm._s(_vm.isConnected ? _vm.$t("Connected") : _vm.$t("Not connected")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }